export default {
    'action.save': 'Save',
    'action.save_changes': 'Save changes',
    'action.cancel': 'Cancel',
    'action.close': 'Close',
    'action.delete': 'Delete',
    'action.edit': 'Edit',
    'action.add': 'Add',
    'action.search': 'Search',
    'action.reset': 'Reset',
    'action.print': 'Print',
    'action.download': 'Download',
    'action.retry': 'Try again',
    'action.back': 'Back',
    'action.next': 'Next',
    'action.confirm': 'Confirm',
    'action.load_more': 'Load more',
    'action.remove': 'Remove',
    'action.stop_using': 'Stop using',
    'form.unsaved_title': 'Leave without saving?',
    'form.unsaved_body': 'The changes on this screen have not been saved yet.',
    'form.discard': 'Leave and discard',
    'form.keep_editing': 'Keep editing',
    'form.required_note': 'Fields marked * are required',
    'form.all_saved': 'Nothing to save yet',
    'form.field_required': 'This field is required',
    'form.fix_marked': 'Fill in the marked fields to save',
    'form.fix_incomplete': 'Some details are missing or too short',
    'dialog.discard_title': 'Discard changes?',
    'dialog.discard_body': 'What you entered here will be lost.',
    'dialog.discard': 'Discard',
    'confirm.remove_title': 'Remove this?',
    'confirm.cannot_undo': 'This cannot be undone.',
    'confirm.remove_named': '{name} will be removed. This cannot be undone.',
    'confirm.stop_title': 'Stop using this?',
    'confirm.stop': 'It will not be used from now on. Records that already used it stay as they are.',
    'confirm.stop_named': '{name} will not be used from now on. Records that already used it stay as they are.',
    'reason.min_hint': '{min, plural, one {At least # character} other {At least # characters}}',
    'reason.too_short': '{min, plural, one {Write at least # character} other {Write at least # characters}}',
    'state.loading': 'Loading…',
    'state.saving': 'Saving…',
    'state.saved': 'Saved',
    'state.empty': 'Nothing here yet',
    'state.error': 'Something went wrong',
    'state.none': '—',
    'table.load_failed': 'This list could not be loaded',
    'table.empty': 'Nothing to show yet.',
    'table.actions': 'Actions',
    'table.sorted_within_loaded': 'Sorted within loaded rows',
    'calendar.previous_month': 'Previous month',
    'calendar.next_month': 'Next month',
    'date.clear': 'Clear the date',
    'date.choose': 'Choose a date from the calendar',
    'time.clear': 'Clear the time',
    'time.choose': 'Choose a time from the list',
    'nav.open_menu': 'Open menu',
    'nav.close_menu': 'Close menu',
    'nav.find_screen': 'Find a screen…',
    'nav.find_screen_label': 'Find a screen in the menu',
    'nav.clear_search': 'Clear the search',
    'nav.no_screen_matches': 'No screen matches “{query}”',
    'nav.press_enter': 'Press Enter to open',
    'nav.read_only': 'Read-only',
    'nav.no_access_title': 'You do not have access to this screen',
    'nav.no_access_body': 'Your role does not include this area. Ask an administrator if you need it.',
    'nav.go_dashboard': 'Go to the dashboard',
    'field.name': 'Name',
    'field.code': 'Code',
    'field.date': 'Date',
    'field.time': 'Time',
    'field.status': 'Status',
    'field.notes': 'Notes',
    'field.reason': 'Reason',
    'field.phone': 'Phone',
    'field.email': 'Email',
    'field.address': 'Address',
    'field.city': 'City',
    'field.country': 'Country',
    'field.currency': 'Currency',
    'field.language': 'Language',
    'field.branch': 'Branch',
    'field.amount': 'Amount',
    'field.total': 'Total',
    'yes': 'Yes',
    'no': 'No',
    'all': 'All',
    'count.items': '{count, plural, one {# item} other {# items}}',
    'count.patients': '{count, plural, one {# patient} other {# patients}}',
    'language.not_ready': 'Not yet available in {language}',
    'language.name.en': 'English',
    'language.name.ar': 'العربية',
    'language.name.es': 'Español',
    'language.name.ur-Latn': 'Roman Urdu',
};
//# sourceMappingURL=common.js.map